const AllGeneList = [
"AATF",
"ABCE1",
"ABCF1",
"ABCF2",
"ABCF3",
"ACADVL",
"ACAT1",
"ACIN1",
"ACLY",
"ACO2",
"ACSF2",
"ACTG1",
"ACTN1",
"ACTN4",
"ACTR2",
"ADAT1",
"ADIRF",
"ADK",
"ADNP",
"AGFG1",
"AGR2",
"AHCTF1",
"AHCY",
"AHNAK",
"AHNAK2",
"AHSA1",
"AIF1L",
"AIP",
"AKAP8",
"AKAP8L",
"AKR1D1",
"ALDOA",
"ALDOC",
"ALKBH5",
"ALYREF",
"ANKRD26",
"ANLN",
"ANP32A",
"ANP32E",
"ANXA2",
"ANXA3",
"ANXA5",
"AP2B1",
"APBB1IP",
"APEX1",
"API5",
"AQR",
"ARCN1",
"ARFGAP1",
"ARGLU1",
"ARHGAP5",
"ARHGEF2",
"ARID3A",
"ARL14EP",
"ARL3",
"ARL6IP5",
"ARMC1",
"ARMT1",
"ARPC1B",
"ARPC2",
"ARPC4",
"ARPC5",
"ARPIN",
"ARPP19",
"ASNS",
"ASPM",
"ASPSCR1",
"ATAD3A",
"ATF1",
"ATG7",
"ATIC",
"ATOX1",
"ATP5F1A",
"ATP5F1B",
"ATP5F1C",
"ATP5PB",
"ATP6V1B2",
"ATRIP",
"ATRX",
"ATXN1",
"ATXN2L",
"ATXN3",
"BAG1",
"BAG3",
"BAP18",
"BAZ1A",
"BAZ1B",
"BAZ2A",
"BBX",
"BCAP31",
"BCAS2",
"BCCIP",
"BCL9L",
"BCLAF1",
"BEND3",
"BIN1",
"BIRC6",
"BMS1",
"BOD1L1",
"BOLA2",
"BPTF",
"BRD3",
"BRD4",
"BRIP1",
"BRIX1",
"BRMS1L",
"BRPF1",
"BTAF1",
"BTF3",
"BZW1",
"BZW2",
"C11orf98",
"C18orf25",
"C19orf53",
"C20orf27",
"C2orf49",
"C5orf24",
"C7orf50",
"C9orf78",
"CACYBP",
"CAD",
"CALD1",
"CALM3",
"CALR",
"CAMK2D",
"CAMK2G",
"CAND1",
"CANX",
"CAP1",
"CAPRIN1",
"CAPZA1",
"CAPZB",
"CASP7",
"CAST",
"CASZ1",
"CBFB",
"CBLL1",
"CBX1",
"CBX3",
"CBX5",
"CBX8",
"CCDC124",
"CCDC59",
"CCDC6",
"CCDC86",
"CCNA2",
"CCND3",
"CCNT1",
"CCS",
"CCT2",
"CCT3",
"CCT4",
"CCT5",
"CCT6A",
"CCT7",
"CCT8",
"CD2BP2",
"CDC37",
"CDC42",
"CDC73",
"CDCA8",
"CDK13",
"CDK2",
"CDK7",
"CDV3",
"CDYL",
"CDYL2",
"CENPE",
"CETN1",
"CFAP20",
"CFDP1",
"CFL1",
"CGGBP1",
"CGN",
"CHAMP1",
"CHD1L",
"CHD2",
"CHD3",
"CHD4",
"CHD8",
"CHERP",
"CHMP1A",
"CHMP1B",
"CHMP2A",
"CHMP2B",
"CHMP3",
"CHMP4A",
"CHMP4B",
"CHMP5",
"CHRAC1",
"CHTF8",
"CHTOP",
"CIAPIN1",
"CIC",
"CKAP4",
"CLASRP",
"CLINT1",
"CLIP1",
"CLTA",
"CLTB",
"CMTR1",
"CNBP",
"CNN2",
"CNN3",
"CNOT1",
"CNOT3",
"CNOT6L",
"COIL",
"COPS7B",
"CORO1C",
"COX4I1",
"CPNE3",
"CPSF1",
"CRABP2",
"CREB1",
"CRIP2",
"CRIPT",
"CRMP1",
"CSDE1",
"CSNK1A1",
"CSNK2A2",
"CSNK2B",
"CSRP1",
"CSRP2",
"CTBP2",
"CTCF",
"CTDP1",
"CTDSPL2",
"CTNNA1",
"CTSD",
"CTTN",
"CUL3",
"CUL4B",
"CUL5",
"CWC15",
"CWC22",
"CWC27",
"CWF19L1",
"CYB5R3",
"CYFIP1",
"CYRIB",
"CZIB",
"DAB2IP",
"DAP",
"DBI",
"DBN1",
"DBNL",
"DCAF1",
"DCPS",
"DCTN2",
"DCTN6",
"DCUN1D5",
"DDB1",
"DDB2",
"DDT",
"DDX1",
"DDX17",
"DDX18",
"DDX21",
"DDX23",
"DDX24",
"DDX39B",
"DDX3X",
"DDX42",
"DDX46",
"DDX5",
"DDX52",
"DDX54",
"DEK",
"DFFA",
"DHCR7",
"DHX15",
"DHX16",
"DHX38",
"DHX9",
"DIAPH1",
"DIDO1",
"DKC1",
"DNAH10",
"DNAJA2",
"DNAJB1",
"DNAJC17",
"DNAJC8",
"DNMT1",
"DNMT3A",
"DNTTIP1",
"DOCK7",
"DPF2",
"DPYSL2",
"DPYSL3",
"DR1",
"DRG2",
"DSP",
"DSTN",
"DTWD1",
"DUS1L",
"DUS2",
"EAF1",
"ECHDC1",
"ECPAS",
"EDF1",
"EEA1",
"EEF1A1P5",
"EEF1A2",
"EEF1B2",
"EEF1D",
"EEF1G",
"EEF2",
"EEFSEC",
"EFHD1",
"EHMT1",
"EHMT2",
"EIF1AX",
"EIF2S1",
"EIF2S2",
"EIF3A",
"EIF3B",
"EIF3C",
"EIF3D",
"EIF3E",
"EIF3G",
"EIF3J",
"EIF4A1",
"EIF4A3",
"EIF4B",
"EIF4E",
"EIF4EBP1",
"EIF4G1",
"EIF4G2",
"EIF4H",
"EIF5A",
"EIF5B",
"ELL",
"ELOA",
"ELOB",
"EMD",
"EMSY",
"ENO1",
"ENO3",
"ENSA",
"EP400",
"EPB41L3",
"EPPK1",
"EPS15L1",
"EPS8",
"ERCC3",
"ERF",
"ESF1",
"ETFA",
"ETV3",
"EXOC2",
"EXOC8",
"EXOSC10",
"EYA3",
"EZR",
"FAM50A",
"FAM53C",
"FANCD2",
"FARSB",
"FASN",
"FAU",
"FBL",
"FBP2",
"FDPS",
"FEN1",
"FER",
"FGFRL1",
"FIP1L1",
"FKBP3",
"FKBP4",
"FKBP8",
"FLNA",
"FLNB",
"FLNC",
"FLYWCH2",
"FNBP4",
"FOSL2",
"FOXA1",
"FOXJ3",
"FOXK2",
"FOXP1",
"FRG1",
"FSCN1",
"FTSJ3",
"FUBP1",
"FUS",
"G6PD",
"GABPA",
"GADD45GIP1",
"GANAB",
"GAPDH",
"GATAD2A",
"GATAD2B",
"GATD3",
"GCLM",
"GCN1",
"GDAP1",
"GDI2",
"GEMIN5",
"GGCT",
"GIGYF2",
"GINS3",
"GIPC1",
"GLS",
"GLUD1",
"GMFB",
"GMFG",
"GMNN",
"GMPS",
"GNL2",
"GOT2",
"GPALPP1",
"GPATCH8",
"GPI",
"GRHL2",
"GRSF1",
"GSE1",
"GSPT1",
"GSTM3",
"GSTO1",
"GTF2E1",
"GTF2E2",
"GTF2F1",
"GTF2F2",
"GTF2H3",
"GTF2I",
"GTF3C1",
"GTF3C4",
"GTF3C5",
"GTPBP4",
"H1-0",
"H1-10",
"H1-2",
"H1-3",
"H1-4",
"H1-5",
"H2AC14",
"H2AC21",
"H2AC6",
"H2AX",
"H2AZ2",
"H2BC13",
"H2BC14",
"H2BC15",
"H2BC17",
"H2BC18",
"H2BC3",
"H2BC4",
"H2BC5",
"H2BC9",
"H2BS1",
"H2BU1",
"H3-3A",
"H3C15",
"H4C1",
"HABP4",
"HACD3",
"HADHA",
"HCFC1",
"HCK",
"HDAC1",
"HDAC2",
"HDAC7",
"HDGF",
"HDGFL2",
"HDLBP",
"HEATR1",
"HELLS",
"HINT1",
"HIRIP3",
"HK1",
"HLTF",
"HMBS",
"HMG20B",
"HMGA1",
"HMGA2",
"HMGB1",
"HMGB2",
"HMGB3",
"HMGN1",
"HMGN2",
"HMGN3",
"HNRNPA0",
"HNRNPA1",
"HNRNPA2B1",
"HNRNPA3",
"HNRNPAB",
"HNRNPC",
"HNRNPD",
"HNRNPF",
"HNRNPH1",
"HNRNPK",
"HNRNPL",
"HNRNPM",
"HNRNPU",
"HNRNPUL2",
"HP1BP3",
"HSD17B4",
"HSP90AA1",
"HSP90AB1",
"HSP90B1",
"HSPA1B",
"HSPA4",
"HSPA4L",
"HSPA5",
"HSPA8",
"HSPA9",
"HSPB1",
"HSPD1",
"HSPE1",
"HTATSF1",
"HYOU1",
"HYPK",
"ICE2",
"IDH2",
"IK",
"IL27",
"ILF3",
"ILKAP",
"IMPACT",
"IMPDH2",
"INIP",
"INO80B",
"INO80D",
"INTS1",
"INTS12",
"INTS3",
"INTS4",
"IPO11",
"IPO5",
"IQGAP1",
"IRF2BP1",
"ISOC1",
"ITPK1",
"JMJD1C",
"JPT1",
"JPT2",
"JUNB",
"KARS1",
"KAT7",
"KBTBD2",
"KCNJ3",
"KDM1B",
"KDM2B",
"KDM3B",
"KDM5C",
"KHDRBS1",
"KHSRP",
"KIAA1143",
"KIF23",
"KIF2A",
"KIFC1",
"KMT2A",
"KPNA1",
"KPNA2",
"KPNA6",
"KRT18",
"LAD1",
"LANCL1",
"LARP1",
"LARP7",
"LASP1",
"LDHA",
"LDHB",
"LENG8",
"LEO1",
"LIG1",
"LIG3",
"LIMA1",
"LIMD2",
"LMNA",
"LMNB1",
"LMNB2",
"LPP",
"LRPPRC",
"LRRC41",
"LRRC59",
"LSM7",
"LXN",
"MACF1",
"MACROH2A1",
"MAD1L1",
"MAGOH",
"MAP2K4",
"MAP4",
"MAP6",
"MAPRE1",
"MAPRE3",
"MARF1",
"MATR3",
"MBD2",
"MBD3",
"MBD4",
"MCM3",
"MCRIP2",
"MDC1",
"MDH1",
"MDH2",
"MECP2",
"MED1",
"MED27",
"MEF2D",
"METTL1",
"METTL3",
"METTL5",
"MFAP1",
"MGA",
"MIDEAS",
"MIP",
"MKI67",
"MLH1",
"MLLT1",
"MNAT1",
"MOB1A",
"MORC2",
"MORC3",
"MORF4L1",
"MPHOSPH10",
"MPHOSPH6",
"MPHOSPH8",
"MRGBP",
"MRPL12",
"MRTO4",
"MSH2",
"MSH6",
"MSL1",
"MSL2",
"MSN",
"MTA1",
"MTA2",
"MTAP",
"MTHFD1",
"MTPN",
"MTREX",
"MTRR",
"MYBBP1A",
"MYEF2",
"MYH10",
"MYH9",
"MYL6",
"MYO6",
"NAA15",
"NAB1",
"NAB2",
"NABP1",
"NACC1",
"NAMPT",
"NANOGNB",
"NANS",
"NAP1L4",
"NAT10",
"NCAPG",
"NCAPH",
"NCBP2",
"NCBP3",
"NCDN",
"NCK1",
"NCL",
"NCOA6",
"NCOR1",
"NCOR2",
"NECAP1",
"NEDD8",
"NELFA",
"NELFE",
"NFATC2",
"NFATC2IP",
"NFIB",
"NFIC",
"NHEJ1",
"NHLRC2",
"NIFK",
"NIPBL",
"NKAP",
"NME2",
"NMNAT1",
"NOB1",
"NOL6",
"NOL7",
"NOLC1",
"NONO",
"NOP14",
"NOP2",
"NOP56",
"NOP58",
"NOP9",
"NOPCHAP1",
"NOSIP",
"NPEPL1",
"NPM1",
"NSD3",
"NSF",
"NSFL1C",
"NSRP1",
"NSUN2",
"NT5DC1",
"NUCKS1",
"NUDC",
"NUDT21",
"NUDT9",
"NUFIP1",
"NUFIP2",
"NUMA1",
"NUP133",
"NUP50",
"NUP98",
"NUSAP1",
"NVL",
"OCIAD1",
"ODR4",
"OGDH",
"OGT",
"OLA1",
"ORC2",
"ORC3",
"ORC4",
"OTUD4",
"OTUD7B",
"OVOL1",
"OXCT1",
"P4HB",
"PA2G4",
"PABPC1",
"PABPN1L",
"PACS1",
"PAF1",
"PAFAH1B1",
"PAICS",
"PAK1IP1",
"PAK2",
"PAPSS1",
"PARK7",
"PARN",
"PARP1",
"PARP8",
"PATZ1",
"PAWR",
"PAXX",
"PCBP1",
"PCBP2",
"PCF11",
"PCLAF",
"PCMT1",
"PCNA",
"PCNP",
"PCYT1A",
"PDAP1",
"PDCD5",
"PDIA3",
"PDIA4",
"PDLIM1",
"PDLIM5",
"PDLIM7",
"PDS5A",
"PDS5B",
"PEBP1",
"PELP1",
"PES1",
"PFKL",
"PFKM",
"PFKP",
"PFN1",
"PGAM1",
"PGD",
"PGK1",
"PGLS",
"PHAX",
"PHB",
"PHC2",
"PHC3",
"PHF10",
"PHF2",
"PHF20L1",
"PHF23",
"PHF3",
"PHF6",
"PHGDH",
"PHIP",
"PHLDB2",
"PIAS4",
"PIP4K2A",
"PIP4K2C",
"PKM",
"PKN2",
"PLEC",
"PLEKHA2",
"PLPBP",
"PML",
"PMVK",
"PNKP",
"PNN",
"POGZ",
"POLA2",
"POLB",
"POLD2",
"POLD3",
"POLDIP3",
"POLE4",
"POLR1E",
"POLR1G",
"POP1",
"PPAN",
"PPHLN1",
"PPIA",
"PPIB",
"PPID",
"PPIG",
"PPIL2",
"PPIL4",
"PPL",
"PPM1G",
"PPME1",
"PPP1CA",
"PPP1CB",
"PPP1R10",
"PPP1R11",
"PPP1R12A",
"PPP1R14B",
"PPP1R2",
"PPP1R8",
"PPP2R1A",
"PPP2R2A",
"PPP2R5C",
"PPP2R5D",
"PPP4R3A",
"PPP4R3B",
"PPWD1",
"PQBP1",
"PRC1",
"PRCC",
"PRDM2",
"PRDX1",
"PRDX2",
"PRDX6",
"PREX1",
"PRKAR2A",
"PRKCSH",
"PRKDC",
"PRKRIP1",
"PRMT1",
"PRMT5",
"PRMT6",
"PRPF19",
"PRPF3",
"PRPF31",
"PRPF38A",
"PRPF38B",
"PRPF4",
"PRPF6",
"PRPF8",
"PRR12",
"PRRC1",
"PRRX1",
"PSIP1",
"PSMA1",
"PSMA3",
"PSMA6",
"PSMA7",
"PSMB5",
"PSMC1",
"PSMC2",
"PSMC5",
"PSMD1",
"PSMD12",
"PSMD3",
"PSMD4",
"PSMD6",
"PSMD7",
"PSMD9",
"PSME1",
"PSME2",
"PSME3IP1",
"PSMG1",
"PSPC1",
"PTBP1",
"PTBP2",
"PTGES3",
"PTPN11",
"PTPN2",
"PUF60",
"PUS1",
"PUS7",
"PWWP2A",
"PYM1",
"QPRT",
"QRICH1",
"QSER1",
"RAB13",
"RAB1A",
"RAB1B",
"RABL6",
"RAC1",
"RACGAP1",
"RAD21",
"RAI1",
"RALY",
"RAN",
"RANBP1",
"RANBP2",
"RB1",
"RBBP5",
"RBBP6",
"RBM10",
"RBM14",
"RBM15",
"RBM17",
"RBM22",
"RBM25",
"RBM26",
"RBM27",
"RBM28",
"RBM33",
"RBM39",
"RBM6",
"RBMX",
"RBP1",
"RBPJ",
"RCC2",
"RCOR1",
"RCOR2",
"RECQL",
"RECQL5",
"REEP5",
"RELB",
"RFC1",
"RFC4",
"RGS10",
"RIDA",
"RIF1",
"RNASEH2B",
"RNF113A",
"RNF114",
"RNGTT",
"RNMT",
"RNPS1",
"ROCK1",
"RPA1",
"RPF2",
"RPL10",
"RPL10A",
"RPL11",
"RPL12",
"RPL13",
"RPL13A",
"RPL14",
"RPL15",
"RPL17",
"RPL18",
"RPL18A",
"RPL19",
"RPL22",
"RPL23",
"RPL23A",
"RPL24",
"RPL26",
"RPL26L1",
"RPL27",
"RPL27A",
"RPL28",
"RPL29",
"RPL3",
"RPL30",
"RPL31",
"RPL32",
"RPL34",
"RPL35",
"RPL35A",
"RPL36",
"RPL36A",
"RPL37",
"RPL37A",
"RPL4",
"RPL5",
"RPL6",
"RPL7",
"RPL7A",
"RPL8",
"RPL9",
"RPN1",
"RPP30",
"RPP38",
"RPRD2",
"RPS10",
"RPS11",
"RPS12",
"RPS13",
"RPS14",
"RPS15",
"RPS15A",
"RPS16",
"RPS17",
"RPS18",
"RPS19",
"RPS2",
"RPS20",
"RPS21",
"RPS23",
"RPS24",
"RPS25",
"RPS27",
"RPS27A",
"RPS28",
"RPS29",
"RPS3",
"RPS3A",
"RPS4X",
"RPS5",
"RPS6",
"RPS6KA4",
"RPS6KB1",
"RPS7",
"RPS8",
"RPS9",
"RPSA",
"RRBP1",
"RREB1",
"RRP1",
"RRP12",
"RRP15",
"RRP1B",
"RRP7BP",
"RRP8",
"RSF1",
"RSL1D1",
"RSRC2",
"RTF1",
"RTF2",
"RTKN",
"RYBP",
"S100A10",
"S100A11",
"S100A16",
"S100A4",
"S100A6",
"SAE1",
"SAFB",
"SAFB2",
"SAP130",
"SAP30",
"SAP30BP",
"SARNP",
"SART1",
"SBDS",
"SCAF1",
"SCAF11",
"SCIN",
"SDHA",
"SEC22B",
"SELENOH",
"SENP3",
"SEPTIN5",
"SEPTIN9",
"SERBP1",
"SERPINH1",
"SET",
"SETD2",
"SF1",
"SF3A1",
"SF3A2",
"SF3A3",
"SF3B1",
"SF3B2",
"SF3B6",
"SFN",
"SFPQ",
"SH3BGRL",
"SH3GL1",
"SH3KBP1",
"SHC1",
"SHMT2",
"SIN3A",
"SIN3B",
"SINHCAF",
"SKP1",
"SLC25A24",
"SLC25A3",
"SLC25A5",
"SLC25A6",
"SLC27A3",
"SLC27A4",
"SLC3A2",
"SLC4A1AP",
"SLC7A5",
"SLC9A3R1",
"SLK",
"SLTM",
"SLU7",
"SMAP",
"SMARCA4",
"SMARCA5",
"SMARCAD1",
"SMARCC1",
"SMARCC2",
"SMC1A",
"SMC3",
"SMC5",
"SMCHD1",
"SMN1",
"SMTN",
"SMYD5",
"SNRNP40",
"SNRPA",
"SNRPA1",
"SNRPB2",
"SNRPG",
"SNRPN",
"SNW1",
"SNX1",
"SNX2",
"SNX6",
"SNX9",
"SOD1",
"SP3",
"SPAG7",
"SPART",
"SPEN",
"SPIN1",
"SPTBN1",
"SPTLC1",
"SRBD1",
"SREK1",
"SRFBP1",
"SRP14",
"SRP72",
"SRRM1",
"SRRM2",
"SRRT",
"SRSF1",
"SRSF10",
"SRSF5",
"SRSF6",
"SS18",
"SS18L1",
"SSB",
"SSBP3",
"SSH3",
"SSRP1",
"STAT1",
"STIP1",
"STMN1",
"STOML2",
"STT3B",
"STXBP1",
"SUB1",
"SUGP1",
"SUGP2",
"SUMO2",
"SUMO3",
"SUPT16H",
"SUPT5H",
"SUZ12",
"SYMPK",
"SYNCRIP",
"SYTL2",
"SZRD1",
"TAF3",
"TAF4",
"TAGLN2",
"TALDO1",
"TARDBP",
"TASP1",
"TBCA",
"TBCB",
"TCEA1",
"TCEAL1",
"TCEAL4",
"TCF3",
"TCOF1",
"TDP1",
"TEAD1",
"TERF2IP",
"TES",
"TFAP2C",
"TFIP11",
"THRAP3",
"THUMPD1",
"THYN1",
"TIA1",
"TIMELESS",
"TJP1",
"TKT",
"TLE3",
"TLK2",
"TLN1",
"TMA16",
"TMA7",
"TMPO",
"TNKS1BP1",
"TOM1L1",
"TOMM20",
"TOMM70",
"TOP1",
"TOP2A",
"TOP2B",
"TP53BP1",
"TPD52L1",
"TPD52L2",
"TPI1",
"TPM1",
"TPM4",
"TPR",
"TPX2",
"TRA2A",
"TRA2B",
"TRERF1",
"TRIM24",
"TRIM25",
"TRIM28",
"TRIM33",
"TRIP12",
"TRIR",
"TRMT6",
"TRPC5",
"TRPS1",
"TSEN54",
"TSN",
"TSNAX",
"TSPYL5",
"TSR1",
"TSSC4",
"TTC9",
"TUBA1A",
"TUFM",
"TWF1",
"TXN",
"TXNDC9",
"TXNRD1",
"U2AF2",
"U2SURP",
"UBA1",
"UBA2",
"UBE2E1",
"UBE2I",
"UBE2K",
"UBE2M",
"UBE2N",
"UBE2T",
"UBE2V1",
"UBE3C",
"UBTF",
"UBXN1",
"UGDH",
"UIMC1",
"UNC45A",
"UNG",
"UPF1",
"UQCRC2",
"USP10",
"USP14",
"USP22",
"USP3",
"USP7",
"UTP20",
"UTP23",
"UTP3",
"UTRN",
"VAPA",
"VAPB",
"VARS1",
"VASP",
"VAV2",
"VCL",
"VCP",
"VDAC1",
"VIM",
"VTA1",
"VWF",
"WAPL",
"WBP11",
"WBP4",
"WDHD1",
"WDR12",
"WDR17",
"WDR33",
"WDR36",
"WDR4",
"WDR43",
"WDR44",
"WDR45B",
"WDR46",
"WDR5",
"WDR70",
"WDR73",
"WDR77",
"WIZ",
"WRNIP1",
"XPC",
"XPO5",
"XPO7",
"XRCC1",
"XRCC5",
"XRCC6",
"XRN2",
"YAP1",
"YARS1",
"YBX1",
"YME1L1",
"YTHDC1",
"YWHAB",
"YWHAE",
"YWHAG",
"YWHAQ",
"YWHAZ",
"YY1",
"ZBTB1",
"ZBTB10",
"ZBTB21",
"ZBTB4",
"ZBTB7A",
"ZBTB7B",
"ZC3H11A",
"ZC3H14",
"ZC3H15",
"ZC3H18",
"ZC3H4",
"ZC3H8",
"ZC3HC1",
"ZFAND1",
"ZFAND6",
"ZFC3H1",
"ZFHX3",
"ZFP91",
"ZFPM2",
"ZFR",
"ZHX2",
"ZHX3",
"ZMAT2",
"ZMYM2",
"ZMYM3",
"ZMYM4",
"ZMYND8",
"ZNF148",
"ZNF207",
"ZNF217",
"ZNF219",
"ZNF260",
"ZNF280C",
"ZNF281",
"ZNF462",
"ZNF512B",
"ZNF516",
"ZNF592",
"ZNF609",
"ZNF638",
"ZNF687",
"ZNF787",
"ZNF800",
"ZRANB2",
"ZYX"
];

export default AllGeneList;